import React, { useState } from 'react'
import { When } from 'react-if'

import './JobListingForm.css'
import FormCurrencyInput from '../../../Components/FormField/FormCurrencyInput'
import FormDropdown from '../../../Components/FormField/FormDropdown'
import ButtonContainer from "../../../Components/CheckableButton/ButtonContainer";
import CheckableButton from "../../../Components/CheckableButton/CheckableButton";

const currencyTypes = ['USD', 'AUD', 'MYR', 'IDR', 'VND', 'SGD', 'NZD']

const buildSalaryPlaceHolder = (salaryType) => {
  return salaryType === 'annual_salary' ? 'annual salary' : 'hourly salary'
}

const Remuneration = (props) => {
  const [salaryPlaceHolder, setSalaryPlaceHolder] = useState(
    buildSalaryPlaceHolder(props.state.salary_type)
  )

  const buildSalaryInput = (isMin, id, label, minimum, value) => {
    return (
      <FormCurrencyInput
        label={label}
        id={id}
        name={id}
        placeholder={
          isMin ? 'Min ' + salaryPlaceHolder : 'Max ' + salaryPlaceHolder
        }
        required
        min={minimum}
        defaultValue={value}
        decimalsLimit={4}
        onValueChange={(value, name) =>
          props.handleCurrencyValueChange(name, value)
        }
      />
    )
  }

  const onRemunerationChanged = (e) => {
    const newHolder = buildSalaryPlaceHolder(e.target.value)
    setSalaryPlaceHolder(newHolder)
    props.handleRemunerationChange(e)
  }

  return (
    props.state.display_salary ?
      <div className='row'>
        <div className='col-lg-3'>
          <FormDropdown
            id='salary_type'
            label='Remuneration'
            required
            onChange={(e) => onRemunerationChanged(e)}
            value={props.state.salary_type}
          >
            <option value='annual_salary'>Annual Salary</option>
            <option value='hourly_salary'>Hourly Salary</option>
          </FormDropdown>
        </div>

        <div className='col-lg-3'>
          <FormDropdown
            label='Currency'
            id='salary_unit'
            className=''
            placeholder='Currency'
            required
            onChange={props.handleFormFieldChange}
            value={props.state.salary_unit}
          >
            <option value='1' hidden>
              Currency type
            </option>
            {currencyTypes.map((item) => {
              return <option value={item}>{item}</option>
            })}
          </FormDropdown>
        </div>
        <div className='col-lg-3'>
          {buildSalaryInput(
            true,
            'salary_min',
            'Minimum Salary',
            '1',
            props.state.salary_min
          )}
        </div>
        <div className='col-lg-3'>
          {buildSalaryInput(
            false,
            'salary_max',
            'Maximum Salary',
            props.state.salary_min,
            props.state.salary_max
          )}
        </div>
      </div>
      :
      <ButtonContainer
        horizontal
        label="Other salary options"
      >
        <CheckableButton
          id="award-rates"
          name="salary_display_option"
          checked={props.state.salary_display_option === "Award Rates"}
          onChange={props.handleRadioChange}
        >
          Award Rates
          </CheckableButton>
        <CheckableButton
          id="negotiable"
          name="salary_display_option"
          checked={props.state.salary_display_option === "Negotiable"}
          onChange={props.handleRadioChange}
        >
          Negotiable
          </CheckableButton>
        <CheckableButton
          id="not-provided"
          name="salary_display_option"
          checked={props.state.salary_display_option === "Not Provided"}
          onChange={props.handleRadioChange}
        >
          Not Provided
          </CheckableButton>
      </ButtonContainer>
  )
}

export default Remuneration
